import React from 'react';

interface DocumentUploadRejectedWarningProps {
  rejected: string[];
}

export function DocumentUploadRejectedWarning({
  rejected,
}: DocumentUploadRejectedWarningProps) {
  const rejectedDetails = rejected.map((message, index) => (
    <React.Fragment key={message}>
      {index > 0 && <br />}
      {message}
    </React.Fragment>
  ));

  return (
    <>
      Couldn&apos;t upload files:
      <br />
      {rejectedDetails}
    </>
  );
}
